<div class="spreadsheet-container">
  <table class="spreadsheet-grid" #spreadsheetTable>

    <!-- Header Row -->
    <tr class="spreadsheet-row">
      <!-- Corner cell -->
      <th class="spreadsheet-header corner-cell"></th>

      <!-- Column headers -->
      <th
        *ngFor="let col of columns"
        class="spreadsheet-header column-header">
        {{ getColumnLabel(col) }}
      </th>
    </tr>

    <!-- Data Rows -->
    <tr *ngFor="let row of rows" class="spreadsheet-row">
      <!-- Row header -->
      <th class="spreadsheet-header row-header">
        {{ getRowLabel(row) }}
      </th>

      <!-- Data cells -->
      <ng-container *ngFor="let col of columns">
        <td
          *ngIf="!isCellHidden(row, col)"
          [class]="getCellClasses(row, col)"
          [attr.rowspan]="getCellSpan(row, col).rowSpan"
          [attr.colspan]="getCellSpan(row, col).colSpan"
          (mousedown)="onCellMouseDown($event, row, col)"
          (mouseenter)="onCellMouseEnter($event, row, col)"
          (dblclick)="onCellDoubleClick(row, col)"
          [title]="getCellContent(row, col)">

          <!-- Table cell content -->
          <div
            *ngIf="getCell(row, col)?.content?.type === 'table'"
            class="cell-content table-content"
            [ngStyle]="getCellStyle(row, col)">
            <div class="table-wrapper" [ngStyle]="getTableWrapperStyle(row, col)"
                 (mouseenter)="onTableMouseEnter($event)">
              <table class="embedded-table">
                <thead *ngIf="getTableHeaders(row, col).length > 0">
                  <tr>
                    <th *ngFor="let header of getTableHeaders(row, col); let i = index"
                        class="table-header"
                        [ngStyle]="getTableHeaderStyle(row, col, i)">
                      {{ header }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let dataRow of getTableDataRows(row, col); let rowIndex = index">
                    <td *ngFor="let cell of dataRow; let colIndex = index"
                        [class]="getTableDataCellClass(row, col, colIndex)"
                        [ngStyle]="getTableDataCellStyle(row, col, rowIndex, colIndex)">
                      {{ cell }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Non-table cell content -->
          <div
            *ngIf="getCell(row, col)?.content?.type !== 'table'"
            class="cell-content"
            [class.has-content]="getCellContent(row, col)"
            [class.static-text]="getCell(row, col)?.content?.type === 'staticText'"
            [class.metric]="getCell(row, col)?.content?.type === 'metric'"
            [class.has-custom-style]="hasCustomStyle(row, col)"
            [class.has-custom-background]="hasCustomBackground(row, col)"
            [class.text-left]="getCellTextAlign(row, col) === 'left'"
            [class.text-center]="getCellTextAlign(row, col) === 'center'"
            [class.text-right]="getCellTextAlign(row, col) === 'right'"
            [ngStyle]="getCellStyle(row, col)">
            {{ getCellContent(row, col) }}
          </div>
        </td>
      </ng-container>
    </tr>

  </table>
</div>
